import { FC, useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

//Actions
import { getPopupBanner } from '../../actions/authAction';

//Assets
import CloseIcon from '../../images/round-close-button.png';
import { getCloudImageUrl } from 'utils';

// Define Interface
type Props = {
  className?: string;
  getPopupBanner: any;
  location: any;
};

interface Image {
  URL: string;
  orientation: string;
  platform: string;
}

interface Banner {
  title: string;
  redirect_url: string;
  page_url: string;
  active: boolean;
  platform: string;
  started_at: string;
  ended_at: string;
  images: Image[];
}

//Hooks
const initValue = {
  title: '',
  platform: null,
  redirect_url: '',
  page_url: '',
  active: false,
  ended_at: null,
  started_at: null,
  images: [],
};

const bannerKeywors = {
  '/': 'home',
  '/sneakers': 'sneaker',
  '/luxury': 'luxury',
  '/madeindonesia': 'madeindo',
  '/streetwear': 'streetwear',
  '/fashion': 'fashion',
  '/apparel': 'apparel',
  '/lifestyle': 'lifestyle',
  '/toys': 'toys',
  '/electronics-collectibles': 'electronics-collectibles',

  'details-sneakers': 'details-sneakers',
  'details-luxury': 'details-luxury',
  'details-madeindonesia': 'details-madeindo',
  'details-streetwear': 'details-streetwear',
  'details-fashion': 'details-fashion',
  'details-apparel': 'details-apparel',
  'details-lifestyle': 'details-lifestyle',
  'details-toys': 'details-toys',
  'details-electronics-collectibles': 'details-electronics-collectibles',
};

const ModalBannerFunction = (location) => {
  const [openModal, setOpenModal] = useState(false);
  const [banner, setBanner] = useState<Banner | null>(null);

  const responsive = window.innerWidth <= 768;
  const pathName = location?.pathname;

  // Function
  const isActive = () => {
    if (!banner) return false;
    if (!moment().isBetween(banner?.started_at, banner?.ended_at)) return false;
    return true;
  };

  const handleDontShowAgain = () => {
    const title = banner?.title ? banner.title.replace(/\s/g, '') : '';

    localStorage.setItem(
      `${title}-ka-popup-banner`,
      JSON.stringify(moment().add(24, 'hours').format()),
    );
    setBanner(null);
    setOpenModal(false);
  };

  const displayImage = () => {
    if (!banner?.images?.length) return;

    const orientation = responsive ? 'portrait' : 'landscape';
    const source = banner.images.filter(
      (img) => img.orientation == orientation,
    )[0];

    return getCloudImageUrl(source.URL, 2000);
  };

  const getBannerKeyword = (): String => {
    try {
      if (bannerKeywors[pathName]) {
        return bannerKeywors[pathName];
      }

      const currentUrl = pathName.split('/');
      if (currentUrl[2] && typeof +currentUrl[2] == 'number') {
        if (bannerKeywors[`details-${currentUrl[1]}`]) {
          return bannerKeywors[`details-${currentUrl[1]}`];
        }
      }

      return '';
    } catch (error) {
      console.log(error);
      return 'null';
    }
  };

  const handleCloseBanner = () => {
    setBanner(null);
    setOpenModal(false);
  };

  const getBanners = async (keyword) => {
    if (!keyword) return;

    try {
      await getPopupBanner(keyword)
        .then((res) => res.data)
        .then((res) => {
          if (res?.data?.length) {
            const data = res.data[0];

            setBanner(data);
          }
        });
    } catch (error) {
      console.log(error, 'DEBUG');
    }
  };

  // use Effect
  useEffect(() => {
    setBanner(null);
    getBanners(getBannerKeyword());
  }, [pathName]);

  useEffect(() => {
    try {
      if (!banner) return;

      if (!isActive()) return;
      const title = banner?.title ? banner.title.replace(/\s/g, '') : '';

      let storedBanner: any = localStorage.getItem(`${title}-ka-popup-banner`);
      if (!storedBanner) {
        setOpenModal(true);
        return;
      }

      storedBanner = JSON.parse(storedBanner);

      const currentDate = moment().format();
      const storedDate = moment(storedBanner).format();
      const diff = moment(currentDate).isAfter(storedDate);

      if (diff) {
        setOpenModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  }, [banner]);

  return {
    openModal,
    banner,
    responsive,
    setOpenModal,
    handleDontShowAgain,
    displayImage,
    handleCloseBanner,
  };
};

const ModalPopupBanner: FC<Props> = ({ className, location }) => {
  const {
    openModal,
    banner,
    handleDontShowAgain,
    displayImage,
    handleCloseBanner,
  } = ModalBannerFunction(location);

  if (!openModal) return null;
  return (
    <Modal
      show={true}
      id="modal-popup-banner"
      className={className}
      centered
      fullscreen={true}
      onHide={handleCloseBanner}
    >
      <div className="banner-wrapper">
        <KickImage
          onClick={handleCloseBanner}
          className="close-icon"
          alt="close icon"
          src={CloseIcon}
        />
        <a href={banner?.redirect_url}>
          <KickImage className="popup-banner" src={displayImage() || ''} alt="..." />
        </a>

        <p className="dont-show-again" onClick={handleDontShowAgain}>
          <u>Don't show me again</u>
        </p>
      </div>
    </Modal>
  );
};
ModalPopupBanner.defaultProps = {
  className: '',
};

const mapDispatchToProps = {};

//@ts-ignore
export default connect(null, mapDispatchToProps)(withRouter(ModalPopupBanner));
